import {Injectable} from '@angular/core';
import {Validators} from '@angular/forms';
import {ObjectValidators} from '@aviary/forms/extensions/form-extensions.types';
import {CardLoginValue, EditNotificationPreferencesValue, EditPatronValue, EmailLoginValue} from '@store/patron/patron.types';
import {CommonValidators} from '@aviary/store/common/common.validators';


@Injectable({providedIn: 'root'})
export class PatronValidators {

  public readonly editPatronInfo: ObjectValidators<EditPatronValue> = {
    preferredName: Validators.maxLength(256),
    phone1: [CommonValidators.phoneNumber, Validators.maxLength(18)],
    phone1Mobile: [],
    phone1Ext: Validators.maxLength(10),
    phone2: [CommonValidators.phoneNumber, Validators.maxLength(18)],
    phone2Mobile: [],
    phone2Ext: Validators.maxLength(10),
    defaultHoldPickupBranchId: [],
    pronounId: [],
    notificationEmail: [Validators.email, Validators.maxLength(320)]
  };

  public readonly editNotificationPreferences: ObjectValidators<EditNotificationPreferencesValue> = {
    phoneSms: [],
    notificationEmail: [Validators.email, Validators.maxLength(320)],
    accountNotifications: [],
    renewNotifications: [],
    expirationNotifications: [],
    receiptNotifications: [],
    holdNotifications: [],
    noticeNotifications: [],
    itemRequestNotifications: [],
    smsTermsAccepted: []
  };

  public readonly emailLogin: ObjectValidators<EmailLoginValue> = {
    email: [Validators.required, Validators.email],
    password: [Validators.required]
  };

  public readonly cardLogin: ObjectValidators<CardLoginValue> = {
    cardNumber: [Validators.required],
    pin: [Validators.required, CommonValidators.pinValidator, Validators.maxLength(256)]
  };
}
